import React from 'react'
import styled from 'styled-components'
import { ExternalLink, PageHeading } from '@broad/ui'

import DocumentTitle from './DocumentTitle'
import InfoPage from './InfoPage'

const Credits = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 13px;

  @media (max-width: 992px) {
    flex-direction: column;
    font-size: 16px;
  }
`

const CreditsSection = styled.div`
  width: calc(${props => props.width} - 15px);

  @media (max-width: 992px) {
    width: 100%;
  }
`

const ContributorList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  line-height: 1.5;

  ul {
    padding-left: 20px;
    margin: 0.5em 0;
    list-style-type: none;
  }
`

const PrincipalInvestigatorList = styled(ContributorList)`
  columns: 2;

  @media (max-width: 992px) {
    columns: 1;
  }
`

const FundingSourceList = styled(ContributorList)`
  li {
    margin-bottom: 1em;
  }
`

const TableStyled = styled.table`
  border: 1px solid black;
  border-collapse: collapse;
`

const TableHeader = styled.th`
  border: 1px solid black;
  border-collapse: collapse;
`

const TableData = styled.td`
  border: 1px solid black;
  border-collapse: collapse;
`


export default () => (
  <InfoPage>
    <DocumentTitle title="About WashU Rare Disease Atlas" />
    <PageHeading id="about-sfari">About WashU Rare Disease Atlas</PageHeading>

    <div>
      <p>
        The WashU Disease Atlas will integrate de-identified, aggregate genomic and phenotypic data into a centralized, accessible resource, accelerating discovery and enabling future translational studies for researchers, clinicians, and families
      </p>

      <p>
        Additional content and documentation will be added as development
        progresses.
      </p>
    </div>
  </InfoPage>
)

